var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "align-stretch justify-start" },
        [
          _vm.currentUser.league && _vm.currentUser.league.seasonId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "8" } },
                [
                  _c("LastMatchdayGamesWidget", {
                    attrs: { seasonId: _vm.currentUser.league.seasonId },
                    on: {
                      heightChange: function ($event) {
                        _vm.lastMatchdayGameHeight = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
            [
              _c("LastPlayersSearch", {
                style: { height: _vm.lastMatchdayGameHeight + "px" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("LastScoutingAnalysesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("ScoutingTasksWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("UploadedGamesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("CapturePlaylistsWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.league && _vm.currentUser.league.seasonId
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("NextMatchdayGamesWidget", {
                    attrs: { seasonId: _vm.currentUser.league.seasonId },
                    on: {
                      heightChange: function ($event) {
                        _vm.nextMatchdayHeight = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("FavoritesWidget", {
                style: { height: _vm.nextMatchdayHeight + "px" },
                attrs: { userId: _vm.currentUser.id },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("ChartsWidget", {
                    staticClass: "mt-3 elevation-2",
                    attrs: {
                      slides: ["playerScoutChart", "playerReportsChart"],
                    },
                    on: {
                      heightChange: function ($event) {
                        _vm.chartsHeight = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("CollectionsWidget", {
                staticClass: "mt-3",
                style: { height: _vm.chartsHeight + "px" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }